import { useEffect, useState } from "react";

/**
 * Tracks whether a page's guided tour should be shown, auto-launching it the
 * first time the user visits (once `ready` data has loaded) and remembering
 * dismissal in localStorage so it doesn't repeat on later visits.
 */
export function useGuidedTour(storageKey, ready = true) {
  const [active, setActive] = useState(false);

  useEffect(() => {
    if (ready && !localStorage.getItem(storageKey)) setActive(true);
  }, [storageKey, ready]);

  const start = () => setActive(true);
  const finish = () => {
    localStorage.setItem(storageKey, "1");
    setActive(false);
  };

  return { active, start, finish };
}
